import React from "react";
import { useQuery } from "@tanstack/react-query";
import { reportService } from "../../services/reports";
import LoadingSpinner from "../Common/LoadingSpinner";

export default function ProfitLossReport({ dateRange }) {
  const { data, isLoading } = useQuery({
    queryKey: ["profit-loss", dateRange],
    queryFn: () => reportService.getProfitLoss(dateRange)
  });

  if (isLoading) return <LoadingSpinner />;

  return (
    <div className="bg-white rounded-lg shadow p-4">
      <h3 className="text-lg font-semibold mb-4">Profit & Loss Statement</h3>
      <div className="space-y-4">
        <div className="border-b pb-2">
          <p className="font-semibold">Revenue</p>
          <p className="text-xl text-green-600">KES {data?.income?.total_revenue?.toLocaleString() || 0}</p>
        </div>
        <div className="border-b pb-2">
          <p className="font-semibold">Cost of Goods Sold</p>
          <p className="text-xl text-red-600">KES {data?.costOfGoodsSold?.toLocaleString() || 0}</p>
        </div>
        <div className="border-b pb-2">
          <p className="font-semibold">Gross Profit</p>
          <p className="text-xl text-blue-600">KES {data?.grossProfit?.toLocaleString() || 0}</p>
        </div>
        <div>
          <p className="font-semibold">Net Profit</p>
          <p className="text-xl font-bold text-green-600">KES {data?.netProfit?.toLocaleString() || 0}</p>
        </div>
      </div>
    </div>
  );
}